export default __webpack_public_path__ + "static/media/ZiroLiveQRCode.05372a9a.png";